// extracted by mini-css-extract-plugin
export default {"cardPago":"UltimosPagosRegistradosComponent_cardPago__mlOus","contenedorUltimosPagos":"UltimosPagosRegistradosComponent_contenedorUltimosPagos__CJ7s1"};